import { ReferrerPayoutStatus } from "@redotech/crdb-enums/referrals/referrer-payout-status";
import * as z from "zod";

export type PayoutStatus = `${ReferrerPayoutStatus}`;
const PayoutStatusSchema: z.ZodType<PayoutStatus, PayoutStatus> =
  z.enum(ReferrerPayoutStatus);

export const ReferrerPayoutSchema = z.object({
  id: z.string(),
  periodStart: z.iso.date(),
  periodEnd: z.iso.date(),
  paidOn: z.iso.date().nullable(),
  /** Cents, stringified to preserve BigInt precision over the wire. */
  amountCents: z.string(),
  status: PayoutStatusSchema,
  payoutMethod: z.string(),
});

export type ReferrerPayout = z.infer<typeof ReferrerPayoutSchema>;
